import React from "react";
import { Button, Modal } from "react-bootstrap";
import { OrdemSolta } from "./types";


interface CriarModalOrdensProps {
	show: boolean;
	onHide: () => void;
	onSubmit: (e: React.FormEvent) => void;
	ordensSoltas: OrdemSolta[];
}

export const CriarModalOrdens: React.FC<CriarModalOrdensProps> = React.memo(
    ({
        show,
        onHide,
        onSubmit,
        ordensSoltas,
    }) => (
        <Modal show={show} onHide={onHide} centered className="_telascustom-modal">
			<Modal.Header closeButton className="_telasmodal-header-custom">
				<Modal.Title className="_telasmodal-title-custom">Telas Soltas</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{ordensSoltas.length > 0 ? (
					<table className="tabela-ordens_Modal">
                    <thead>
                        <tr>
                            <th>Ordem</th>
                            <th>Tela</th>
                            <th>Data</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ordensSoltas.map((ordem) => (
                            <tr key={ordem.imp_Key}>
                                <td>{ordem.imp_Ordem}</td>
                                <td>{ordem.imp_Tela}</td>
                                <td>{new Date(ordem.imp_Data).toLocaleDateString()}</td>
                                <td>{ordem.imp_Status}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
				) : (
					<p>Nenhuma ordem solta encontrada.</p>
				)}
			</Modal.Body>
			<Modal.Footer className="_telasmodal-footer-custom">
				<Button variant="outline-secondary" onClick={onHide} className="btn-cancel">
					Fechar
				</Button>

                <Button variant="primary" onClick={onSubmit} className="btn-save">
					Salvar
				</Button>
			</Modal.Footer>
		</Modal>
    )
);
